export default {
  initialize: state => ({
    type: 'SEARCH_INITIALIZE',
    state,
  }),
  setSearchValue: searchValue => ({
    type: 'SEARCH_SET_VALUE',
    searchValue,
  }),
  setIsFuzzy: isFuzzy => ({
    type: 'SEARCH_SET_IS_FUZZY',
    isFuzzy,
  }),
};
